export type ServiceQueueDialogMessages = {
  deleteTitle: string;
  deleteContent: string;
  deleteCancel: string;
  deleteConfirm: string;
};

export const SERVICE_QUEUE_DIALOG_MESSAGES: ServiceQueueDialogMessages = {
  deleteTitle: "Excluir Fila de Atendimento",
  deleteContent: "Tem certeza de que deseja excluir esta fila de atendimento?",
  deleteCancel: "Cancelar",
  deleteConfirm: "Confirmar",
};
